import styled from '@emotion/styled'
import { space, SpaceProp } from 'components/layout/primitives/utils'

/**
 * Used to add more horizontal space between layouts
 */
export const HSpace = styled.div<SpaceProp>`
	display: inline-flex;
	flex: none;
	height: 100%;
	width: ${space};
`
